<!--
 * @Author: Zj
 * @Date: 2022-01-06 14:50:03
 * @LastEditTime: 2024-02-22 14:36:44
 * @LastEditors: zj
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \gdp_cloud_app\src\views\medical-edu\detail\article\index.vue
-->
<template>
  <div class="container">
    <div class="content">
      <div v-if="$route.query && $route.query.id"  class="len">学习时长：{{ timeLengh }} 分钟</div>

      <div class="content_top">{{ArrayData.dataName}}</div>
      <div class="content_media">
        <div class="mar_left">{{ArrayData.creatorTrueName}}</div>
        <div class="mar_center">{{ArrayData.gmtCreate}}</div>
        <div class="mar_right">阅读量： {{ArrayData.viewVolume}}</div>
      </div>
      <div>
        <div class="content_bottom">
          <div class="mar_top_l">
            <!-- 富文本编辑器使用 -->
            <div class="ql-container ql-snow">
              <div class="ql-editor">
                <div class="htmlMain" v-html="ArrayData.details">{{ArrayData.details}}}</div>
              </div>
            </div>
            <!-- 富文本编辑器使用 -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      ArrayData: {},
      url: ''
    };
  },
  created () {
    this.getDetail(this.$route.query.dataId);
  },
  mounted () {
    if (this.$route.query && this.$route.query.id) {
      this.getViewTime()
      this.timeupdate()
    }
  },
  // 销毁完成状态
  destroyed () {
    // 清除延时器
    window.clearTimeout(this.timer);
  },
  methods: {
    getDetail (dataId) {
      // @ts-ignore
      this.$axios
        .post('/article/writing/get/list', {
          data: {
            // @ts-ignore
            id: dataId
          },
          // @ts-ignore
          version: this.$version
          // @ts-ignore
        })
        .then((res) => {
          if (res.status) {
            this.ArrayData = res.data;
            // @ts-ignore
            this.url =
              // @ts-ignore
              this.utils.mixedFileUrl(res.data.coverUrl);
          }
        });
    },
    // 获取时长
    getViewTime () {
      this.$axios.post('edu/study/history/get/view/time', {
        data: {
          dataId: this.$route.query.dataId,
          planCourseId: this.$route.query.id,
          moduleId: this.$route.query.moduleId
        // videoLength: parseInt(document.getElementById('video').duration)
        },
        version: this.$version
      }).then((res) => {
        if (res.status) {
          this.timeLengh = res.data ? res.data.viewTime : 0
        }
      })
    },
    // 每隔六十秒调用一次接口
    timeupdate () {
      if (!this.timeStatus) {
        return;
      }
      this.timeStatus = false
      this.timer = setInterval(() => {
        this.timeStatus = true;
        this.timeLengh = this.timeLengh + 1
        this.getTimeLength()
      }, 60000)
    },

    // 调用时长接口
    getTimeLength () {
      this.$axios.post('edu/study/history/statistic/time', {
        data: {
          dataId: this.$route.query.dataId,
          planCourseId: this.$route.query.id,
          moduleId: this.$route.query.moduleId
          //  videoLength
        },
        version: this.$version
      }).then(res => {
        if (res.data) {
          // console.log('sucess')
        }
      })
    }
  }
};
</script>
<style scoped lang='scss'>
.content {
  margin-top:52px;
  padding: 0 14px;
  .content_top {
    font-family: PingFangSC-Semibold;
    font-size: 21px;
    color: #333333;
    letter-spacing: 0.27px;
    font-weight: 600;
  }
  .content_media {
    display: flex;
    padding:14px 0;
    .mar_left {
      width: 30%;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #333333;
      font-weight: 400;
    }
    .mar_center {
      flex: 1;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #9e9e9e;
      font-weight: 400;
    }
    .mar_right {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #9e9e9e;
      font-weight: 400;
    }
  }
}
.content_bottom ::v-deep img{
    width: 100% !important;
}
.len{
  margin:10px 0;
}
</style>

